// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__cTLvD","rotate":"Spinner_rotate__hOggP","path":"Spinner_path__SRnu5","dash":"Spinner_dash__Z-cgG"};